import { apiClient, ENDPOINTS, STORAGE_KEYS } from '@/lib/api/client';
import type { AdminLoginResponse, AdminMeResponse } from '@/types/api';

export function getAdminToken(): string | null {
  return localStorage.getItem(STORAGE_KEYS.adminToken);
}

export function getAdminUsername(): string | null {
  return localStorage.getItem(STORAGE_KEYS.adminUsername);
}

export function clearAdminSession(): void {
  localStorage.removeItem(STORAGE_KEYS.adminToken);
  localStorage.removeItem(STORAGE_KEYS.adminUsername);
}

export function isAdminAuthenticated(): boolean {
  return Boolean(getAdminToken());
}

export async function loginAdmin(username: string, password: string): Promise<AdminLoginResponse> {
  const response = await apiClient.post<AdminLoginResponse>(
    ENDPOINTS.admin.login,
    { username, password },
    { skipAuth: true, portal: null },
  );
  localStorage.setItem(STORAGE_KEYS.adminToken, response.access_token);
  localStorage.setItem(STORAGE_KEYS.adminUsername, response.username);
  return response;
}

export async function fetchAdminMe(): Promise<AdminMeResponse> {
  return apiClient.get<AdminMeResponse>(ENDPOINTS.admin.me, { portal: 'admin' });
}

export function logoutAdmin(): void {
  clearAdminSession();
}
